import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { SmoothScroll } from "./components/SmoothScroll";
import Home from "./pages/Home";
import ProfilePage from "./pages/ProfilePage";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <SmoothScroll />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/perfil/:slug" element={<ProfilePage />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="top-center" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
